import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

export default class extends Controller {
  static values = { url: String }

  declare urlValue: string

  reload(event: Event) {
    const breederCageId = (event.target as HTMLInputElement).value
    const frame = document.getElementById("combine_cage_form")

    if (!frame) return

    const url = `${this.urlValue}&breeder_cage_id=${breederCageId}`
    $(frame).attr("src", url)
  }
}
